import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import AudioList from './AudioList';
import TabContainer from './ui/TabContainer';
import TextDisplay from './ui/TextDisplay';
import StanzaList from './StanzaList';
import SongList from './SongList';
import SagnirList from './SagnirList';
import BookPageList from './BookPageList';
import Breadcrumb from './ui/Breadcrumb';
import BookmarkButton from './ui/BookmarkButton';
import HandritBookView from './ui/HandritBookView';
import _ from 'underscore';

import config from './../config';
import helpers from './../lib/helpers';

function BookView(props) {
	const [data, setData] = useState(null);
	const [hideStanzaList, setHideStanzaList] = useState(false);
	const [hideSongList, setHideSongList] = useState(false);
	const [hidePageList, setHidePageList] = useState(false);
	const [hideSagnirList, setHideSagnirList] = useState(false);
	const [showPage, setShowPage] = useState(null);
	const [showVolume, setShowVolume] = useState(null);

	useEffect(() => {
		if (props.match.params.id) {
			setHideStanzaList(false);
			setHidePageList(false);
			setHideSagnirList(false);

			helpers.fetch(config.apiRoot+'/api/book/'+props.match.params.id, (json) => {
				setData(json);
			}, null, 'number');
		}
	}, [props.match.params.id]);

	useEffect(() => {
		if (props.searchParams) {
			let params = helpers.parseSearchParams(props.searchParams);

			if (params.bokasida) {
				setShowPage(params.bokasida);
			}
			if (params.bindi) {
				setShowVolume(params.bindi);
			}
		}
	}, [props.searchParams]);

	return (

			data &&
			<div className="content-container">

				<Breadcrumb currentElTitle={data.number} />

				<div>
					<BookmarkButton id={data.id} title={data.number} type="book" className="float-right" />
					<h2>{data.number}{
						data.name && data.name != data.number &&
						<React.Fragment>
							<br/><small>{data.name}</small>
						</React.Fragment>
					}</h2>
				</div>

				<div className="row mt-5">

					<div className="col-12 col-lg-8">

						{
							data.history && data.history.length > 0 &&
							<TextDisplay className="mt-4" text={data.history} />
						}

					</div>

					<div className="col-12 col-lg-4">

						<table className="table metadata-table">
							<tbody>
								{
									data.origin &&
									<tr><td><label>Uppruni</label></td><td>{data.origin}</td></tr>
								}
								{
									data.dating &&
									<tr><td><label>Aldur</label></td><td>{data.dating}</td></tr>
								}
								{
									data.script_type &&
									<tr><td><label>Handritsgerð</label></td><td>{helpers.metadataList([data.script_type], helpers.routerUrls['baekur'], 'id', 'name', 'tegund')}</td></tr>
								}
								{
									data.collection && data.collection.museum &&
									<tr><td><label>Varðveislustaður</label></td><td>{helpers.metadataList([data.collection.museum], helpers.routerUrls['safn'], 'id', 'name')}</td></tr>
								}
								{
									data.collection &&
									<tr><td><label>Samsafn</label></td><td>{helpers.metadataList([data.collection], helpers.routerUrls['samsafn'], 'id', 'name')}</td></tr>
								}
								{
									data.publisher &&
									<tr><td><label>Útgefandi</label></td><td>{helpers.metadataList([data.publisher], helpers.routerUrls['einstaklingar'], 'id', 'name')}</td></tr>
								}
								{
									data.author && data.author.length > 0 &&
									<tr><td><label>{data.author.length > 1 ? 'Höfundar' : 'Höfundur'}</label></td><td>{helpers.metadataList(data.author, helpers.routerUrls['einstaklingar'], 'id', 'name')}</td></tr>
								}
								{
									data.url &&
									<tr><td><label>Vefslóð</label></td><td><a href={data.url} target="_blank">{helpers.trim(data.url, 30)}</a></td></tr>
								}
							</tbody>
						</table>

					</div>

				</div>

				<TabContainer useRouter={'true'} selectedTab={props.match.params.tab} baseUrl={helpers.routerUrls['baekur']+props.match.params.id}>

					{
						data.handrit_xml &&
						<div tabname="sidur"
							tabtitle="Handritamyndir">
								<HandritBookView src={'/flettibok/'+(showPage ? '?hsida='+showPage : '')+'#'+data.handrit_xml.split('/').join('\\').replace('.xml', '')+(showVolume ? '/'+showVolume : '')+'.xml'} />
						</div>
					}

					<BookPageList book={data.id}
						tabname="myndir"
						tabtitle="Síður"
						hideAsTab={hidePageList}
						searchParams={props.searchParams}
						onResponse={(data) => {
							setHidePageList(data.length == 0);
					   }}
					>
					</BookPageList>

					<SagnirList bok={data.id}
						tabname="sagnir"
						tabtitle="Sagnir/ævintýri"
						hideAsTab={hideSagnirList}
						searchParams={props.searchParams}
						onResponse={(data) => {
							setHideSagnirList(data.length == 0);
					   }}
					>
						<p className="mb-3">
							<small>
								Sagnir/ævintýri í þessari bók.<br/>
								<Link to={helpers.routerUrls['sagnir_aevintyri']+'?bok='+data.id}>Leita að sögnum og ævintýrum úr þessari bók/handriti</Link>
							</small>
						</p>
					</SagnirList>

					<StanzaList book={data.id}
						tabname="erindi"
						tabtitle="Erindi"
						hideAsTab={hideStanzaList}
						searchParams={props.searchParams}
						onResponse={(data) => {
							setHideStanzaList(data.length == 0);
					   }}
					>
						<p className="mb-3"><small>Erindi í þessari bók.</small></p>
					</StanzaList>

					<SongList book={data.id}
						tabname="log"
						tabtitle="Lög"
						hideAsTab={hideSongList}
						searchParams={props.searchParams}
						onResponse={(data) => {
							setHideSongList(data.length == 0);
					   }}
					>
						<p className="mb-3"><small>Lög í þessari bók.</small></p>
					</SongList>

				</TabContainer>
			</div>

	)
}

export default BookView;
